// extracted by mini-css-extract-plugin
module.exports = {"root":"Skeleton_root__R49I_","shimmer":"Skeleton_shimmer__10WyN","light":"Skeleton_light__uWYzA Skeleton_root__R49I_","darker":"Skeleton_darker__eLbXW Skeleton_root__R49I_"};